import { InternalAxiosRequestConfig } from 'axios';

import { useUserStore } from '@/store/user-store';

export const attachOrganizationToken = (config: InternalAxiosRequestConfig) => {
  const organizationToken = useUserStore.getState().organizationToken;

  if (config.skipAttachOrganizationToken) {
    return config;
  }

  if (organizationToken) {
    config.headers['s-organization-token'] = organizationToken;
  }

  return config;
};
